'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import React, { Fragment, useMemo } from 'react';
import Collapse from '@mui/material/Collapse';
import { useId } from '../hooks/useId';
import List from '@mui/material/List';
import { NavItem } from './NavItem';
import { NavItemButton } from './NavItemButton';
import { composeEventHandlers } from '../utils/composeEventHandlers';
import { navCssClassNames } from './navCssClassNames';
const subItemSelected = (items) => {
    return items.some((subItem) => subItem.selected);
};
const StyledNavItemButton = styled(NavItemButton)(({ open, disableEndIconAnimation }) => ({
    '.MuiButton-endIcon': {
        transitionDuration: '300ms',
        ...open && !disableEndIconAnimation && {
            transform: 'rotate(180deg)'
        }
    }
}));
export const NavItemCollapse = React.forwardRef(({ children, startIcon, endIcon, endIconSelected, selected, onClick, id, items, ...props }, ref) => {
    const hasItems = Array.isArray(items) && items.length > 0;
    const [open, setOpen] = React.useState(selected || props.open || Boolean(hasItems && subItemSelected(items)));
    const buttonId = useId(id, 'navItemCollapseButton');
    const collapseId = useId(id, 'navItemCollapseList');
    const toggleCollapse = () => {
        setOpen(!open);
    };
    const onClickEvents = composeEventHandlers(toggleCollapse, onClick);
    const renderEndIcon = useMemo(() => {
        if (selected && endIconSelected) {
            return endIconSelected;
        }
        return _jsx(KeyboardArrowDown, {});
    }, [selected, endIconSelected]);
    return (_jsxs(Fragment, { children: [_jsx(StyledNavItemButton, { ...props, "aria-controls": collapseId, "aria-expanded": open, as: undefined, className: navCssClassNames.itemCollapseButton, endIcon: renderEndIcon, id: buttonId, onClick: onClickEvents, open: open, orientation: 'side', ref: ref, selected: selected, startIcon: startIcon, children: children }), hasItems && (_jsx(Collapse, { in: open, children: _jsx(List, { "aria-labelledby": buttonId, className: navCssClassNames.itemCollapseMenu, id: collapseId, children: items.map((item, index) => (_jsx(NavItem, { children: _jsx(NavItemButton, { level: 1, orientation: 'side', ...item, children: item.label }) }, index))) }) }))] }));
});
NavItemCollapse.displayName = 'NavItemCollapse';
